import React from 'react';
import Logo from "../../Images/ETH_TURIN__logo111.png";
import {
    Nav,
    NavWrapper,
    LogoImg,
    ConnectButton
} from "./HeaderElements";

const Header = ({ onConnect, connectedAddress }) => {
    const formatAddress = (address) => {
        if (!address) return "";
        return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
    };

    return (
        <Nav>
            <NavWrapper>
                <LogoImg src={Logo} />

                <ConnectButton onClick={onConnect}>
                    {connectedAddress ? formatAddress(connectedAddress) : "Connect Wallet"}
                </ConnectButton>
            </NavWrapper>
        </Nav>
    );
};

export default Header;
